import { Edge, Node } from '@xyflow/react';
import { IVlanItem, GlobalSettingsType } from 'src/context/global/types';

import { getConfiguration } from './get-configuration';

export const exportConfiguration = async ({
  nodes: allNodes,
  edges,
  vlans,
  cfgName,
  targetId,
  globalSettings,
}: {
  nodes: Node[];
  edges: Edge[];
  vlans: IVlanItem[];
  cfgName: string;
  targetId: string;
  globalSettings: GlobalSettingsType;
}) => {
  const file = await getConfiguration({
    nodes: allNodes,
    edges,
    vlans,
    cfgName,
    targetId,
    isAutoDeploy: false,
    globalSettings,
  });

  const element = document.createElement('a');
  element.href = URL.createObjectURL(file);
  element.download = `${cfgName}.cfg`;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
  document.body.removeChild(element);
};
